import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const FooterContainer = styled.footer`
  background: #F5F5F5;
  color: #333;
  padding: 3rem 2rem 2rem;
  margin-top: 4rem;
  font-family: ${theme.fonts.main};
  width: 100%;
  box-sizing: border-box;
`;

export const FooterWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3rem;
  align-items: start;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 0 1rem;
  }
`;

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionTitle = styled.h3`
  color: #2c3e50;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid ${theme.colors.primary};
  padding-bottom: 0.5rem;
  display: inline-block;
  width: fit-content;
`;

export const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding-left: 0; /* Ensure no extra left padding */
`;

export const FooterLink = styled.a`
  color: #666;
  text-decoration: none;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.3rem; /* Reduce gap to minimize right shift */

  &:hover {
    color: #3498db;
    transform: translateX(5px);
  }

  i {
    font-size: 1.1rem;
    width: 20px;
    flex-shrink: 0;
  }

  /* 邮箱链接特殊样式 */
  &[href^="mailto:"] {
    font-weight: 600;
    font-size: 1rem;
    color: #3498db;
    
    &:hover {
      color: #2980b9;
    }
  }
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem; /* Reduce gap for better alignment */
  color: #666;
  font-size: 0.95rem;
  line-height: 1.5;

  i {
    color: ${theme.colors.primary};
    font-size: 1.1rem;
    margin-top: 0.2rem;
    min-width: 20px;
    flex-shrink: 0;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const SocialItem = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem; /* Reduce gap for better alignment */
  color: #666;
  text-decoration: none;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  padding: 0.5rem;
  border-radius: 6px;
  position: relative;

  &:hover {
    color: #333;
    background: rgba(52, 152, 219, 0.1);
    transform: translateY(-2px);
    
    .qr-preview {
      opacity: 1;
      visibility: visible;
      transform: translateY(-10px);
    }
  }
`;

export const SocialIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  flex-shrink: 0;

  i {
    font-size: 1.3rem;
    color: ${theme.colors.primary};
  }

  .material-icons {
    font-size: 1.3rem;
    color: ${theme.colors.primary};
  }
`;

export const SocialText = styled.span`
  flex: 1;
`;

export const QRCodePreview = styled.div`
  position: absolute;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
  
  /* 默认在右侧显示 */
  left: calc(100% - 200px);
  top: -60px;
  transform: translateY(-50%);

  img {
    width: 150px;
    height: 150px;
    display: block;
    border-radius: 4px;
  }

  /* 右侧箭头 */
  &::before {
    content: '';
    position: absolute;
    left: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid white;
  }

  @media (max-width: 1024px) {
    /* 中等屏幕：改为左侧显示 */
    left: auto;
    right: calc(100% + 15px);
    
    /* 左侧箭头 */
    &::before {
      left: auto;
      right: -8px;
      border-right: none;
      border-left: 8px solid white;
    }
  }

  @media (max-width: 768px) {
    /* 移动端：改为上方居中显示 */
    left: 30%;
    right: auto;
    top: auto;
    bottom: calc(100% + 15px);
    transform: translateX(-50%);
    
    img {
      width: 120px;
      height: 120px;
    }

    /* 下方箭头 */
    &::before {
      left: 50%;
      right: auto;
      top: 100%;
      bottom: auto;
      transform: translateX(-50%);
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid white;
      border-bottom: none;
    }
  }

  @media (max-width: 480px) {
    img {
      width: 100px;
      height: 100px;
    }
  }
`;

export const Copyright = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #ddd;
  text-align: center;
  color: #666;
  font-size: 0.9rem;
`;

export const Logo = styled.div`
  margin-bottom: 1.5rem;
  
  h2 {
    color: #2c3e50;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
    letter-spacing: 1px;
  }
  
  p {
    color: #666;
    margin: 0.5rem 0 0 0;
    font-size: 0.9rem;
  }
`;

export const FooterLogo = styled.img`
  height: 60px;
  width: auto;
  margin-bottom: 0.5rem;
  display: block;
  
  @media (max-width: 768px) {
    height: 50px;
  }
`;